var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSecurityGradient24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0033AD"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M12 .333L0 5.667v8c0 7.4 5.12 14.32 12 16 6.88-1.68 12-8.6 12-16v-8L12 .333zm0 14.654h9.333C20.627 20.48 16.96 25.373 12 26.907V15H2.667V7.4L12 3.253v11.734z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecurityGradient24Px);
export default __webpack_public_path__ + "static/media/ic-security-gradient-24-px.6885dc2fd15a8d57bee7923b7f08537a.svg";
export { ForwardRef as ReactComponent };